// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// local
// views
import Notification from 'app/components/commons/notification/Notification';
// actions
import { clearNotification } from 'app/redux/actions/notification-message.action';
// stylesheets
import styles from './Notification.module.scss';

class NotificationTimeout extends Component {
  timeout = null;

  componentDidUpdate() {
    const { message } = this.props.notification;
    // if there is a message to be displayed
    if (message) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      // start a timeout for it
      this.timeout = setTimeout(() => this.handleDismiss(), 5000);
    }
  }

  componentWillUnmount() {
    // clear the timeout if it exists
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  handleDismiss = () => {
    // clear the timeout if it exists
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    // clear the notification from redux
    this.props.dispatch(clearNotification());
  };

  render() {
    const { isError, message } = this.props.notification;
    if (!message) {
      return null;
    }
    return (
      <Notification
        isError={isError}
        message={message}
        className={this.props.notification.message ? styles.notificationShow : styles.notification}
      />
    );
  }
}

NotificationTimeout.propTypes = {
  notification: PropTypes.object,
  dispatch: PropTypes.func
};

const mapStateToProps = state => ({
  notification: state.notification
});
export default connect(mapStateToProps)(NotificationTimeout);
